import "./acceptReturn.css";

import axios, { all } from "axios";

import * as Action from "../../../../../store/redux/terminal_reducer.js";
import { useReducer, useState , useRef} from "react";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import IsLoading from "../../../../../IsLoading";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import AlertBar from "../../../../../AlertBar.jsx";

let saleReturnFetchData;

export default function AcceptReturn({ setOpenModal }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const returnRequestRef=useRef({}),returnPendingRef=useRef(false);
  const [returnReason,setReturnReason]=useState("");
  const [alert, setAlert] = useState(false);
  const [switchView, setSwitchView] = useState("filter-search");

  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const staffData = useSelector(
    (state) => state.clientFunction?.companiesDB?.staffData,
  );

  const { registerData } = useSelector((state) => state.terminalActions);
  const { enqueueSnackbar } = useSnackbar();

  const acceptReturnData = useSelector(
    (state) => state.terminalActions?.acceptReturn,
  );

  console.log("ACCEPT RETURN DATA: ", acceptReturnData);
  function handleDisplayComp() {
    switch (switchView) {
      case "filter-search":
        return <FilterSearchData />;
      case "sale-payload":
        return <AcceptReturnData />;
      default:
        return <FilterSearchData />;
    }
  }

  function FilterSearchData() {
    const [saleReturnData, setSaleReturnData] = useReducer(
      (state, updates) => {
        return { ...state, ...updates };
      },
      {
        dateFrom: "",
        dateTo: "",
        saleId: "",
        customerName: "",
        customerId: "",
        customerPhoneNumber: "",
        saleReturnFetchData: [],
      },
    );

    const payload = {
      clientId: companyData?.clientId,
      dateFrom: saleReturnData.dateFrom,
      dateTo: saleReturnData.dateTo,
      saleId: saleReturnData.saleId,
      customerName: saleReturnData.customerName,
      customerId: saleReturnData.customerId,
      customerPhoneNumber: saleReturnData.customerPhoneNumber,
    };

    const apiFetchSaleReturns = async () => {
      if (
        !saleReturnData.dateFrom &&
        !saleReturnData.dateTo &&
        !saleReturnData.saleId &&
        !saleReturnData.customerName &&
        !saleReturnData.customerId &&
        !saleReturnData.customerPhoneNumber
      ) {
        enqueueSnackbar("Please provide at least one search criteria.", {
          variant: "warning",
        });

        return;
      }

      setLoading(true);

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/inventory_terminal/sale_return/fetch`,
          payload,
          {
            timeout: 30000,
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const { status, message, returnFetchData } = data;
        console.log("FILTER DATA: ", data);

        switch (status) {
          case 200:
            saleReturnFetchData = returnFetchData;

            enqueueSnackbar(message, {
              variant: "success",
            });

            break;

          default:
            enqueueSnackbar(message, {
              variant: "error",
            });
        }
      } catch (error) {
        enqueueSnackbar(
          error.response?.data?.message || "Unable to fetch sales.",
          {
            variant: "error",
          },
        );
      } finally {
        setLoading(false);
      }
    };
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space1">
          <div className="fx-ac fx-jb space3">
            <figure className="contactTopFig fx-ac space1">
              <span className="actRtrnDate fx-ac space1">
                Date:{" "}
                <span className="tag">
                  from{" "}
                  <input
                    type="date"
                    value={saleReturnData.dateFrom}
                    onChange={(event) =>
                      setSaleReturnData({
                        dateFrom: event.target.value,
                      })
                    }
                  />
                </span>
                <span className="tag">
                  to{" "}
                  <input
                    type="date"
                    value={saleReturnData.dateTo}
                    onChange={(event) =>
                      setSaleReturnData({
                        dateTo: event.target.value,
                      })
                    }
                  />
                </span>
              </span>
            </figure>
            <figure className="contactTopFig fx-ac space1">
              <span className="fx-ac space1">
                Total <span className="tag">48 data found</span>
              </span>
              <button
                className="fs1 fw500 fx-ac fx-jb"
                onClick={() => apiFetchSaleReturns()}
              >
                <AddOutlinedIcon fontSize="medium" /> <span>Fetch Record</span>
              </button>
            </figure>
          </div>
          <div className="acctpRtrnInputsCont space2">
            <div className="field">
              {/* <label>Sales ID</label> */}

              <input
                type="text"
                placeholder="Sales ID"
                value={saleReturnData.saleId}
                onChange={(event) =>
                  setSaleReturnData({
                    saleId: event.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              {/* <label>Customer Name</label> */}

              <input
                type="text"
                placeholder="Customer Name"
                value={saleReturnData.customerName}
                onChange={(event) =>
                  setSaleReturnData({
                    customerName: event.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              {/* <label>Customer ID</label> */}

              <input
                type="text"
                placeholder="Customer ID"
                value={saleReturnData.customerId}
                onChange={(event) =>
                  setSaleReturnData({
                    customerId: event.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              {/* <label>Customer Phone</label> */}

              <input
                type="text"
                placeholder="Customer Phone Number"
                value={saleReturnData.customerPhoneNumber}
                onChange={(event) =>
                  setSaleReturnData({
                    customerPhoneNumber: event.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="saleReturnDataCont fx-cl space1">
          {saleReturnFetchData?.map((sale, index) => (
            <div
              key={index}
              className="saleRtrnItemCard fx-cl space2"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(Action.dispatchAcceptReturnData(sale));
                setSwitchView("sale-payload");
              }}
            >
              <div className="fx-ac fx-jb space1">
                <div>
                  <strong>Sales ID:</strong> {sale.saleId}
                </div>

                <div>
                  <strong>Date: </strong>
                  {new Date(sale.createdAt).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </div>
              </div>

              <div className="filterdCardDetail">
                <div className="space1">
                  <strong>Customer:</strong> {sale.customer_name}
                </div>
                <div className="space1">
                  <strong>Total Items:</strong> {sale.soldItems.length}
                </div>
                <div className="space1">
                  <strong>Representive:</strong> {sale.soldBy?.name}
                </div>
                <div className="space1">
                  <strong>Payment Method:</strong> {sale.payment?.method}
                </div>
                <div className="space1">
                  <strong>Payment Status:</strong> {sale.payment?.status}
                </div>
                <div className="space1">
                  <strong>Change:</strong> {sale.totals?.change}
                </div>
                <div className="space1">
                  <strong>Discount:</strong> {sale.totals?.discount?.amount}
                </div>
                <div className="space1">
                  <strong>Subtotal:</strong> {sale.totals?.subtotal}
                </div>
                <div className="space1">
                  <strong>Grand total:</strong>
                  {sale.totals?.total}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  function AcceptReturnData() {
    const itemsToReturn = acceptReturnData?.soldItems?.filter(
      (item) => item.assigned === true,
    );
    const allSelected =
      acceptReturnData?.soldItems?.every((item) => item.assigned) ?? false;

    console.log("RETURNINGS:", itemsToReturn);
    // ITEM SELLING PAYLOAD DATA----------------------

    const updatePayload = itemsToReturn?.map(
      ({ sku, soldQuantity, batchNo, pricing, returningQuantity }) => ({
        sku,
        returningQuantity,
        batchNo,
        subTotal: pricing.subTotal,
        clientId: staffData?.clientId,
        warehouseId: staffData?.warehouses[0]?.warehouseId,
        inventoryId: staffData?.inventories[0]?.inventoryId,
      }),
    );

    //   CREATING ACCEPT RETURN ID------------
    const d = new Date();
    const YY = String(d.getFullYear()).slice(-2);
    const MM = String(d.getMonth() + 1).padStart(2, "0");
    const DD = String(d.getDate()).padStart(2, "0");
    const HH = String(d.getHours()).padStart(2, "0");
    const MMIN = String(d.getMinutes()).padStart(2, "0");
    const SS = String(d.getSeconds()).padStart(2, "0");

    const itemReturnId = returnRequestRef.current[acceptReturnData?.saleId] ||= `RETURN-${window.crypto.randomUUID()}`;

    const acceptReturnPayloads = {
      returnId: itemReturnId,
      inventoryId: acceptReturnData?.inventoryId,
      reason: returnReason,
      inventoryUpdatePayload: updatePayload,
      returningDataPayload: {
        itemReturnId: itemReturnId,
        registerId: registerData?.registerId,
        salesId: acceptReturnData?.saleId,
        returningItems: itemsToReturn?.map(item=>({...item,returningQuantity:item.returningQuantity??item.soldQuantity,reason:returnReason})),
        customerName: acceptReturnData?.customer_name,
        customerId: acceptReturnData.customerId,
        subTotal: acceptReturnData?.totals?.subtotal,
        total: acceptReturnData?.totals?.total,
        createdAt: new Date(),
      },
    };

    const [assigned, setAssign] = useState(false);
    const checkAllState = () =>
      acceptReturnData?.soldItems.filter(
        (item, index) => (item.assigned = true),
      );

    async function apiProcessReturned() {
      if(returnPendingRef.current)return;
      if(!returnReason.trim()){setAlert({type:"error",message:"Enter the return reason."});return;}
      returnPendingRef.current=true;
      setLoading(true);
      await axios
        .post(
          `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${acceptReturnData?.clientId || companyData?.clientId}/inventory_terminal/sale_return/return_items`,
          acceptReturnPayloads,
        )
        .then((response) => {
          console.log(response?.status || "REQUEST_FINISHED");
          if ([200,201].includes(response.data.status)) {
            setLoading(false);
            delete returnRequestRef.current[acceptReturnData?.saleId];
            setReturnReason("");
            setAlert({
              message: `${response.data.message}`,
              type: "success",
            });
          } else {
            setAlert({
              message: `${response.data.message}`,
              type: "error",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          setAlert({
            message: `${"error: something went wrong!"}`,
            type: "error",
          });
          console.log(error?.code || "REQUEST_FAILED");
          setLoading(false);
        }).finally(()=>{returnPendingRef.current=false;});
    }

    function updateQty(index, qty, available) {
      if (Number(available) >= Number(qty)) {
        if (qty > 0) {
          dispatch(Action.updateReturingQty({ index, qty }));
        } else {
          console.log("Cannot be less than One item");
        }
      } else {
        console.log("Item out of stock:", index);
      }
    }

    function insertQty(index, qty, available) {
      if (Number(available) >= Number(qty)) {
        if (qty > 0) {
          dispatch(Action.insertReturingQty({ index, qty }));
        } else {
          console.log("Cannot be less than One item");
        }
      } else {
        console.log("Item out of stock:", index);
      }
    }

    return (
      <div id="acceptReturnData" className="fx-cl space2">
        <div className="fx-cl space1">
          <div className="fx-ac fx-jb space3">
            <figure className="contactTopFig fx-ac space1">
              <span className="actRtrnDate fx-ac space1">
                Date: <span className="tag">{acceptReturnData?.createdAt}</span>
                <span className="tag">
                  Qty:
                  {acceptReturnData?.soldItems.length}
                </span>
              </span>
            </figure>
            <figure className="contactTopFig fx-ac space1">
              <span className="fx-ac space1">
                Total <span className="tag">48 data found</span>
              </span>
              <button
                className="fs1 fw500 fx-ac fx-jb"
                onClick={() => {
                  setSwitchView("filter-search");
                }}
              >
                <AddOutlinedIcon fontSize="medium" /> <span>Back</span>
              </button>
            </figure>
          </div>
          <div className="acctpRtrnInputsCont space2">
            <div className="field">
              {/* <label>Sales ID</label> */}
              {acceptReturnData?.saleId}
            </div>

            <div className="field">
              {/* <label>Customer Name</label> */}

              {acceptReturnData?.customer_name}
            </div>

            <div className="field">{acceptReturnData?.totals?.subtotal}</div>

            <div className="field">{acceptReturnData?.totals?.total}</div>
          </div>
        </div>

        <div className="saleReturnDataCont fx-cl space1">
          <table className="fx-cl space1">
            <thead>
              <tr className="saleRtrnItem">
                <th className="fx-ac space2">
                  <figure
                    onClick={() => {
                      if (allSelected === true) {
                        dispatch(
                          Action.assignAllItemtoReturn({ assigned: false }),
                        );
                      } else {
                        dispatch(
                          Action.assignAllItemtoReturn({ assigned: true }),
                        );
                      }
                    }}
                    className={`ItemCheck fx-ac fx-jc ${allSelected && "allSelected"}`}
                  >
                    {allSelected && <DoneAllIcon fontSize="medium" />}
                  </figure>
                  <span>SKU</span>
                </th>
                <th>Product</th>
                <th>Quantity</th>
                <th>Return Qty</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody className="fx-cl spacem">
              {acceptReturnData?.soldItems.map((item, index) => {
                return (
                  <tr className="saleRtrnItem" key={index}>
                    <td className="fx-ac spacem">
                      <figure
                        onClick={() => {
                          if (item.assigned === true) {
                            dispatch(
                              Action.assignItemtoReturn({
                                index,
                                assigned: false,
                              }),
                            );
                          } else {
                            dispatch(
                              Action.assignItemtoReturn({
                                index,
                                assigned: true,
                              }),
                            );
                          }
                        }}
                        className={`ItemCheck ${item.assigned === true && "checkedItem"}`}
                      >
                        &nbsp;
                      </figure>
                      <span>{item.sku}</span>
                    </td>

                    <td>
                      <strong>{item.name}</strong>
                    </td>

                    <td>
                      {item.assigned === true ? (
                        <input type="number" defaultValue={item.soldQuantity} />
                      ) : (
                        <span>{item.soldQuantity}</span>
                      )}
                    </td>
                    <td>
                      <span
                        className="fx-ac spacem"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button
                          onClick={() =>
                            updateQty(
                              index,
                              Number(
                                (item?.returningQuantity ??
                                  item?.soldQuantity) - 1,
                              ),
                              item.soldQuantity,
                            )
                          }
                        >
                          <RemoveCircleOutlineIcon
                            fontSize="medium"
                            style={{ color: "#f35e6a" }}
                          />
                        </button>
                        <input
                          className="itemQuanty"
                          type="text"
                          value={item?.returningQuantity || item?.soldQuantity}
                          onChange={(event) =>
                            insertQty(
                              index,
                              Number(event.target.value),
                              item.soldQuantity,
                            )
                          }
                        />
                        <button
                          onClick={() =>
                            updateQty(
                              index,
                              Number(
                                (item?.returningQuantity ??
                                  item?.soldQuantity) + 1,
                              ),
                              item.soldQuantity,
                            )
                          }
                        >
                          <AddCircleOutlineIcon fontSize="medium" />
                        </button>
                      </span>
                    </td>
                    <td>
                      {item.assigned === true ? (
                        <input
                          type="number"
                          defaultValue={item.pricing.subTotal}
                        />
                      ) : (
                        <span>{item.pricing.subTotal}</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="fx-ac fx-jb space3">
            <span>&nbsp;</span>
            <label>Return Reason<input aria-label="Return Reason" required value={returnReason} onChange={event=>setReturnReason(event.target.value)}/></label>
<button onClick={() => apiProcessReturned()}>Return</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {alert && <AlertBar />}
      {loading && <IsLoading />}

      <div
        id="acceptReturns"
        className="fx-cl space2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fx-ac fx-jb space3">
          <div className="fx-cl space1">
            <h3 className="fs6 fw500">
              <span>Accept Returning Items </span>{" "}
              <span style={{ color: "var(--primary-color)" }}>
                {" "}
                from the Customer
              </span>
            </h3>
            <span className="fs3">
              Your Complete List of Saved Client Contacts
            </span>
          </div>

          <button
            className="btnCloseacceptRtrn fx-ac fx-jc"
            onClick={() => setOpenModal(false)}
          >
            <CloseOutlinedIcon style={{ fontSize: "3.1rem" }} />
          </button>
        </div>

        {handleDisplayComp()}
      </div>
    </>
  );
}
